<template>
  <!-- TODO: 参考https://h5.lanhushipin.cn/html/yinsi.html 调整内容，重点关注三方SDK目录 -->
  <div class="privacy-policy">
    <h1>搜机网隐私权政策</h1>
    <p>版本更新日期： 2025 年 2 月 11 日</p>
    <p>版本生效日期： 2025 年 2 月 11 日</p>
    <p>序言</p>
    <p>
      欢迎您使用搜机网！搜机网由北京泽雨昌盛科技有限公司（以下称“我们”、“平台”或“搜机网”）运营。搜机网是一款由我们提供服务的工具产品，为说明搜机网会如何收集、使用和存储您的个人信息及您享有何种权利，我们将通过本指引向您阐述相关事宜。我们极度重视您的用户隐私。您在使用我们的服务时，我们可能会收集和使用您的相关信息。我们希望通过本《隐私政策》向您说明，在使用我们的服务时，我们如何收集、使用、储存和分享这些信息，以及我们为您提供的访问、更新、控制和保护这些信息的方式。本《隐私政策》与您所使用的服务息息相关，希望您仔细阅读，在需要时，按照本《隐私政策》的指引，作出您认为适当的选择。本《隐私政策》中涉及的相关技术词汇，我们尽量以简明扼要的表述，并提供进一步说明的链接，以便您的理解。
      您使用或继续使用我们的服务，即意味着同意我们按照本《隐私政策》收集、使用、储存和分享您的相关信息。依据《中华人民共和国网络安全法》、《信息安全技术个人信息安全规范》（GB/T）及相关法律法规制定了《搜机网隐私政策》（“本政策”）作为《搜机网用户服务协议》的组成部分，希望通过本政策帮助您了解以下内容：
    </p>
    <p>一、我们如何收集和使用您的个人信息</p>
    <p>二、我们如何使用Cookie和同类技术</p>
    <p>三、我们如何共享、转让、公开披露您的个人信息</p>
    <p>四、我们如何保护您的个人信息</p>
    <p>五、您如何管理您的个人信息</p>
    <p>六、我们如何处理未成年人的个人信息</p>
    <p>七、适用法律及管辖</p>
    <p>八、本政策如何更新</p>
    <p>九、信息安全</p>
    <p>十、您如何联系我们</p>
    <p>十一．第三方SDK</p>
    <p>我们深知个人信息对您的重要性，并会尽全力保护您的个人信息安全。 我们在本隐私政策中所提及的收集、使用、管理、共享及转让的个人信息包括加粗及带有下划线标识的个人敏感信息以及其他的个人信息。
      我们致力于维持您对我们的信任，并恪守以下原则：权责一致原则、目的明确原则、选择同意原则、最少够用原则、确保安全原则、主体参与原则、公开透明原则等。我们承诺将按业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。
      希望您在使用我们的服务前仔细阅读并确认您已经充分理解本政策所写明的内容，您点击同意后即视为您接受本政策的内容，并且同意授权我们按照本隐私政策收集、使用、保存和共享您的相关信息。</p>
    <p>一、我们如何收集和使用您的个人信息</p>
    <p>我们会按照如下方式收集您在使用服务时主动提供的，以及通过自动化手段收集您在使用功能或接受服务过程中产生的信息：</p>
    <p>1.1 注册、登录、认证</p>
    <p>1.1.1 注册、登录帐号</p>
    <p>a.当您注册、登录搜机网及相关服务时，您可以通过手机号创建帐号，并且您可以完善相关的<span style="font-weight: bold;color:#409EFF">网络身份识别信息（头像、昵称、密码）</span>，收集这些信息是为了帮助您完成注册。</p>
    <p>1.1.2 播放浏览</p>
    <p>a.日志信息包括： 您主动提供的信息：反馈、发布
      ：含通过GPS信息、WLAN接入点、蓝牙和基站等传感器信息获取到的精确地理位置信息及通过网络位置信息（例如基站、IP及WLAN）获取的大致地理位置信息，地理位置信息是个人敏感信息，若您拒绝提供，不会影响搜机网其他功能的正常使用。
    </p>
    <p>b.日志信息，指您使用我们的服务时，系统可能通过cookies或其他方式自动采集的技术信息，包括：</p>
    <p>设备或软件信息，例如您的移动设备或用于接入我们服务的其他程序所提供的配置信息、您的IP地址和移动设备所用的版本和设备识别码；</p>
    <p>在使用我们服务时搜索或浏览的信息，例如您在使用我们服务时浏览或要求提供的其他信息和内容详情；</p>
    <p>您通过我们的服务分享的内容所包含的信息（元数据），例如拍摄或上传的共享照片或录像的日期、时间或地点等。</p>
    <p>1.3 发布</p>
    <p>1.3.1 信息发布</p>
    <p>a.您发布素材资源内容时，我们将收集您发布的信息，并展示您的昵称、头像、发布内容和信息。</p>
    <p>b.您使用发布图片、音视频功能时，我们会请求您授权相机、照片权限。您如果拒绝授权提供，将无法使用此功能，但不影响您正常使用搜机网的其他功能。</p>
    <p>1.3.2 消息通知</p>
    <p>
      您知悉并同意，对于您在使用产品或服务的过程中以API接口形式发送通知消息，用于用户消息告知。；此外，我们也可能会以短信、电话的方式，为您提供服务、功能或活动等商业性信息的用途，但请您放心，如您不愿接受这些信息，您可以通过手机短信中提供的退订方式进行退订，也可以直接与我们联系进行退订。
    </p>
    <p>1.4 搜索 您使用搜机网的搜索服务时，我们会收集您的搜索关键字信息、日志记录。为了提供高效的搜索服务，部分前述信息会暂时存储在您的本地存储设备之中，并可向您展示搜索结果内容、搜索历史记录。</p>
    <p>1.6您提供的信息</p>
    <p>您通过我们的服务向其他方提供的共享信息，以及您使用我们的服务时所储存的信息；</p>
    <p>其他方分享的您的信息；</p>
    <p>其他方使用我们的服务时所提供有关您的共享信息。</p>
    <p>（三）购买产品及服务</p>
    <p>您办理搜机网会员或购买搜机网提供的产品与服务时，我们会通过系统为您生成购买订单，订单中载明您所购买的产品或服务信息、您应支付的金额及购买时间 ，我们收集这些必要信息是为了帮助您顺利完成交易、保障您的交易安全、方便您查询订单信息。
    </p>
    <p>（四）安全运行</p>
    <p>
      为提高您使用搜机网平台提供服务的安全性，保护您或其他用户或公众的人身财产安全免遭侵害，更好地预防钓鱼网站、欺诈、网络漏洞、计算机病毒、网络攻击、网络侵入等安全风险，更准确地识别违反法律法规和搜机网相关协议的情况，我们可能使用或整合您的
      设备信息、日志信息等，来综合判断您账号及交易风险、进行身份验证、检测及防范安全事件，并依法采取必要的记录、审计、分析、处置措施。</p>
    <p>1、设备信息：我们会根据您在平台安装及使用中授予的具体权限，接收并记录您所使用的 设备相关信息（例如设备型号、设备设置、唯一设备标识符等软硬件特征信息）、设备所在位置相关信息（例如IP地址）。</p>
    <p>请注意，单独的设备信息、日志信息是无法识别特定自然人身份的信息。如果我们将这类非个人信息与其他信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，则在结合使用期间，这类非个人信息将被视为个人信息。</p>
    <p>（五）使用规则</p>
    <p>我们收集您的个人信息后，将严格按照以下规则使用：</p>
    <p>1、我们会严格遵照法律法规及本隐私政策使用您的个人信息。</p>
    <p>2、我们将依法用技术手段对您的个人信息加密、去标识化或匿名化处理。</p>
    <p>3、在您注销账号时，我们将对您的账号和个人信息1小时内进行删除。</p>
    <p>4、当我们需要将您的个人信息用于本政策未载明的其它用途时，我们会再次征求您的同意。</p>
    <p>1. 我们可能将在向您提供服务的过程之中所收集的信息用作下列用途：</p>
    <p>1.1向您提供服务；</p>
    <p>1.2确保我们向您提供的产品和服务的安全性；</p>
    <p>1.3帮助我们设计新服务，改善我们现有服务；</p>
    <p>1.4使我们更加了解您如何接入和使用我们的服务，从而回应您的需求，例如语言设定、位置设定、帮助服务和指示，或对您和其他用户作出其他方面的回应；</p>
    <p>1.5软件认证或管理软件升级；</p>
    <p>1.6让您参与有关我们产品和服务的调查。</p>
    <p>
      1.7为了让您有更好的体验、改善我们的服务或您同意的其他用途，在符合相关法律法规的前提下，我们可能将通过某一项服务所收集的信息，以汇集信息的方式，用于我们的其他服务。例如，在您使用我们的一项服务时所收集的信息，可能在另一服务中用于向您提供特定内容，或向您展示与您相关的、非普遍推送的信息。如果我们在相关服务中提供了相应选项，您也可以授权我们将该服务所提供和储存的信息用于我们的其他服务。
    </p>
    <p>涉及个人隐私权限具体的使用情况及目的方式范围如下：</p>
    <p>1.权限：permission.Camera权限</p>
    <p>目的：使用摄像头支持拍摄服务</p>
    <p>场景：1.修改头像。</p>
    <p>2.权限：permission.READ_EXTER NAL_STORAG E 读取外置存储 器</p>
    <p>目的：允许 App 读取外置存储器</p>
    <p>场景：可以读取本地图库，用户修改头像，选择素材等。</p>
    <p>3.权限：permissioin.WRITE_EXTER NAL_STORAG E 写入外置存储器</p>
    <p>目的：允许 App 写入外置存储器</p>
    <p>场景：下载的图片、视频、zip资源，可以存可以存储本地.</p>
    <p>（六）征得授权同意的例外</p>
    <p>根据相关法律法规规定，以下情形中收集您的个人信息无需征得您的授权同意：</p>
    <p>1、与国家安全、国防安全有关的；</p>
    <p>2、与公共安全、公共卫生、重大公共利益有关的；</p>
    <p>3、与犯罪侦查、起诉、审判和判决执行等有关的；</p>
    <p>4、出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；</p>
    <p>5、所收集的个人信息是您自行向社会公众公开的；</p>
    <p>6、从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；</p>
    <p>7、根据您的要求签订合同所必需的；</p>
    <p>8、用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；</p>
    <p>9、为合法的新闻报道所必需的；</p>
    <p>10、学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；</p>
    <p>11、法律法规规定的其他情形。</p>
    <p>请您理解，我们向您提供的功能和服务是不断更新和发展的，如果某一功能或服务未在前述说明中且收集了您的信息，我们会通过页面提示、交互流程、公告等方式另行向您说明信息收集的内容、范围和目的，以征得您的同意。
      如我们停止运营搜机网平台或服务，我们将及时停止继续收集您个人信息的活动，将停止运营的通知以逐一送达或公告的形式通知您，对所持有的个人信息进行删除或匿名化处理。</p>
    <p>（七）我们可能分享的您的信息</p>
    <p>1.除以下情形外，未经您同意，我们以及我们的关联公司不会分享您的个人信息：</p>
    <p>1.1我们以及我们的关联公司，可能将您的个人信息与我们的关联公司、合作伙伴分享（他们可能并非位于您所在的法域），用作下列用途：</p>
    <p>1.1.1向您提供我们的服务；</p>
    <p>1.1.2实现”我们可能如何使用收集的信息”部分所述目的；</p>
    <p>1.1.3履行我们在本《隐私政策》中的义务和行使我们的权利；</p>
    <p>1.1.4理解、维护和改善我们的服务。</p>
    <p>2.如我们或我们的关联公司分享您的个人信息，我们将努力确保在使用您的个人信息时遵守本《隐私政策》及我们要求其遵守的其他适当的保密和安全措施。</p>
    <p>3.我们或我们的关联公司还可能为以下需要而保留、保存或披露您的个人信息：</p>
    <p>3.1由于部分当地法律法规要求而必须保留的信息；</p>
    <p>3.2遵守法院命令或其他法律程序的规定而必须保留，或披露的信息；</p>
    <p>3.3遵守相关政府机关的要求而必须保留，或披露的信息；</p>
    <p>3.4为遵守适用的法律法规、维护社会公共利益，或保护我们的客户、我们或我们的集团公司、其他用户或雇员的人身和财产安全或合法权益所合理必需的用途。</p>
    <p>（八）您可能分享的信息</p>
    <p>1. 您可通过使用我们服务分享信息</p>
    <p>
      1.1我们的多项服务，可让您不仅与自己的社交网络，也与使用该服务的所有用户公开分享您的相关信息，例如，您在我们的服务中所上传或发布的信息（包括您公开的个人信息、您建立的名单）、您对其他人上传或发布的信息作出的回应，以及包括与这些信息有关的位置数据和日志信息。使用我们服务的其他用户也有可能分享与您有关的信息（包括位置数据和日志信息）。特别是，我们的社交媒体服务，是专为使您与世界各地的用户共享信息而设计，您可以使共享信息实时、广泛地传递。只要您不删除共享信息，有关信息会一直留存在公共领域。
    </p>
    <p>1.2请您谨慎考虑通过我们的服务上传、发布和交流的信息内容。在一些情况下，您可通过我们某些服务的隐私设定来控制有权浏览您共享信息的用户范围。如要求从我们的服务中删除您的相关信息，请通过该等特别服务条款提供的方式操作。</p>
    <p>2. 您分享的敏感个人信息</p>
    <p>2.1某些个人信息因其特殊性可能被认为是敏感个人信息，例如您的种族、宗教、个人健康和医疗信息等。相比其他个人信息，敏感个人信息受到更加严格的保护。</p>
    <p>2.2请注意，您在使用我们的服务时所提供、上传或发布的内容和信息（例如有关您社交活动的照片等信息），可能会泄露您的敏感个人信息。您需要谨慎地考虑，是否在使用我们的服务时披露相关敏感个人信息。</p>
    <p>2.3您同意按本《隐私政策》所述的目的和方式来处理您的敏感个人信息。</p>
    <p>二、我们如何使用Cookie和同类技术</p>
    <p>
      为保证平台正常运行，我们会在您的计算机或移动设备上存储名为Cookie的小数据文件。Cookie通常包含标识符、站点名称以及一些号码及字符。借助于Cookie，我们能够存储您的偏好等数据，以此帮助您免去重复填写个人信息、输入历史搜索内容等繁琐动作。您可根据自己的偏好管理或删除Cookie，如通过浏览器设置选项清除计算机上保存的所有Cookie，但如果您这么做，则需要在每一次访问搜机网时亲自更改用户设置，而且您之前所记录的相应信息也均会被删除，并且可能会对您所使用服务的安全性有一定影响。
    </p>
    <p>三、我们如何共享、转让、公开披露您的个人信息</p>
    <p>（一）共享</p>
    <p>我们不会向搜机网平台服务提供者以外的公司、组织和个人共享您的个人信息，但以下情况除外：</p>
    <p>1、在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。</p>
    <p>2、在法定情形下的共享：我们可能会根据法律法规规定、诉讼争议解决需要，或按行政、司法机关依法提出的要求，对外共享您的个人信息。</p>
    <p>3、当您使用搜机网移动端账号登录我们与我们关联公司运营的其他平台，为方便您使用，我们会将本政策第一条中搜集的所有信息与前述产品或服务共享，如您的会员剩余时长，功能使用频率等。</p>
    <p>（二）转让</p>
    <p>我们将不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</p>
    <p>1、在明确获得您的同意的前提下，我们会向其他方转让您的个人信息；</p>
    <p>2、在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会在要求新的持有您个人信息的公司、组织继续接受此隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。</p>
    <p>（三）公开披露</p>
    <p>我们仅会在以下情况下，公开披露您的个人信息：</p>
    <p>1、获得您明确的同意后；</p>
    <p>2、基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。</p>
    <p>（四）共享、转让、公开披露个人信息时事先征得授权同意的例外</p>
    <p>以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：</p>
    <p>1、与国家安全、国防安全有关的；</p>
    <p>2、与公共安全、公共卫生、重大公共利益有关的；</p>
    <p>3、与犯罪侦查、起诉、审判和判决执行等司法或行政执法有关的；</p>
    <p>4、出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>
    <p>5、您自行向社会公众公开的个人信息；</p>
    <p>6、从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</p>
    <p>四、我们如何保护您的个人信息</p>
    <p>
      1、我们已使用符合业界标准的安全防护措施保护您提供的个人信息，防止数据遭到未经授权访问、公开披露、使用、修改、损坏或丢失。我们会采取一切合理可行的措施，保护您的个人信息。例如，我们对搜机网平台提供HTTPS协议安全浏览方式；我们会使用加密技术确保数据的保密性；我们会使用受信赖的保护机制防止数据遭到恶意攻击；我们会部署访问控制机制，确保只有授权人员才可访问个人信息；以及我们会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。
    </p>
    <p>2、我们会采取合理可行的措施，尽力避免收集无关的个人信息，且仅会在达成本政策所述目的所需的期限或法定期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。</p>
    <p>
      3、我们仅允许有必要知晓这些信息的员工、合作伙伴访问个人信息，并为此设置了严格的访问权限控制、权限审批流程和监控机制。我们同时要求可能接触到您个人信息的所有人员履行相应的保密义务。如果第三方未履行保密义务，可能会被我们追究法律责任并被我们终止合作。
    </p>
    <p>4、互联网并非绝对安全的环境，而且电子邮件、即时通讯、及与其他用户的交流方式并未加密，我们强烈建议您不要通过此类方式发送个人信息。请使用复杂密码，协助我们保证您的账号安全。</p>
    <p>
      5、在不幸发生个人信息安全事件后，我们将按照法律法规的要求向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。事件相关情况我们将以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，上报个人信息安全事件的处置情况。
    </p>
    <p>6.我们仅在本《隐私政策》所述目的所必需的期间和法律法规要求的时限内保留您的个人信息。</p>
    <p>7.<span style="font-weight: bold;color:#409EFF">我们仅在身份验证（实名认证）时临时采集人脸图像。</span>数据经过加密，仅用于一次性验证，并在验证后立即删除。我们不会存储、分析或共享任何生物识别数据。</p>
    <p>五、您如何管理您的个人信息</p>
    <p>我们非常重视您对您个人信息的管理，保护您对于您个人信息访问、更正以及撤回同意、删除的权利。您的权利包括：</p>
    <p>（一）删除您的个人信息</p>
    <p>在以下情形中，您可以向我们提出删除个人信息的请求：</p>
    <p>1、如果我们处理个人信息的行为违反法律法规；</p>
    <p>2、如果我们收集、使用您的个人信息，却未征得您的同意；</p>
    <p>3、如果我们处理个人信息的行为违反了与您的约定；</p>
    <p>4、如果您注销了搜机网账户；</p>
    <p>5、如果我们终止服务及运营。</p>
    <p>
      若我们决定响应您的删除请求，我们还将同时通知从我们获得您的个人信息的第三方，要求其及时删除，除非法律法规另有规定，或这些第三方获得了您的授权。当您从我们的服务中删除信息后，我们可能不会立即在备份系统中删除相应的信息，但会在被备份更新时删除这些信息。
    </p>
    <p>（二）改变您授权同意的范围</p>
    <p>每个业务功能需要一些基本的个人信息才能得以完成，除此之外，如果您希望撤销同意我们额外收集、使用和披露的其他个人信息，您可以通过联系方式与我们联系以收回您的授权同意。</p>
    <p>当您收回同意后，我们将不再处理相应的个人信息。但您收回同意的决定，不会影响此前基于您的授权而开展的个人信息处理。</p>
    <p>（三）注销账户</p>
    <p>
      您可以根据自己的选择随时注销您的搜机网账户。您可以在我们的产品中直接申请注销账户或联系我们协助您注销账户，账户注销成功后立即生效。您注销账户后，我们将停止为您提供产品或服务，并依据您的要求，我们将删除您的个人信息，法律法规另有规定外。
    </p>
    <p>注销路径：我的-&gt;设置-&gt;账户安全-&gt;注销账号</p>
    <p>（四）响应您的上述请求</p>
    <p>为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。</p>
    <p>
      对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际的请求，我们可能会予以拒绝
    </p>
    <p>在以下情形中，按照法律法规要求，我们将无法响应您的请求：</p>
    <p>1、与个人信息控制者履行法律法规规定的义务相关的;</p>
    <p>2、与国家安全、国防安全直接相关的;</p>
    <p>3、与公共安全、公共卫生、重大公共利益直接相关的;</p>
    <p>4、与刑事侦查、起诉、审判和执行判决等直接相关的;</p>
    <p>5、个人信息控制者有充分证据表明个人信息主体存在主观恶意或滥用权利的;</p>
    <p>6、出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的;</p>
    <p>7、响应个人信息主体的请求将导致个人信息主体或其他个人、组织的合法权益受到严重损害的;</p>
    <p>8、涉及商业秘密的。</p>
    <p>六、我们如何处理未成年人的个人信息</p>
    <p>（一）我们的产品、网站和服务主要面向成人，如果没有父母或监护人的同意，未成年人不得创建自己的用户账号。
      如您为未成年人的，建议您请您的父母或监护人仔细阅读本隐私政策，并在征得您的父母或监护人同意的前提下使用我们的服务或向我们提供信息。我们非常重视对未成年人信息的保护。如果您是未满18周岁的未成年人，您的监护人需要仔细阅读本《隐私政策》并同意或授权您同意依照本《隐私政策》使用我们产品及/或服务。如果您是未满14周岁的未成年人，您的监护人需要仔细阅读本《隐私政策》并明示同意您依照本《隐私政策》使用我们产品及/或服务。
    </p>
    <p>（二）对于经父母或监护人同意使用我们的产品或服务而收集未成年人个人信息的情况，我们只会在法律法规允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用、共享、转让或披露此信息。</p>
    <p>（三）如果我们发现自己在未事先获得可证实的服务同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关数据。</p>
    <p>（四）如果您/您的监护人不同意本《隐私政策》的任何内容，您应该立即停止使用我们产品及/或服务。</p>
    <p>七、您的个人信息如何在全球范围转移</p>
    <p>（一）原则上，我们在中华人民共和国境内收集和产生的个人信息，将存储在中华人民共和国境内。</p>
    <p>（二）由于我们通过遍布全球的资源和服务器供产品或服务，这意味着，在获得您的授权同意后，您的个人信息可能会被转移到您使用产品或服务所在国家/地区的境外管辖区，或者受到来自这些管辖区的访问。</p>
    <p>
      （三）此类管辖区可能设有不同的数据保护法，甚至未设立相关法律。在此类情况下，我们会确保您的个人信息得到在中华人民共和国境内足够同等的保护。例如，我们会请求您对跨境转移个人信息的同意，或者在跨境数据转移之前实施数据去标识化等安全举措。
    </p>
    <p>八、隐私政策的修订和通知</p>
    <p>（一）为给您提供更好的服务,搜机网及先关服务将不时更新与变化，我们会适时对本隐私政策进行修订，该等修订构成本隐私政策的一部分并具有等同于本隐私政策的效力。但未经你明确同意，我们不会削减你依据当前生效的本隐私政策所应享受的权利。
    </p>
    <p>
      （二）本隐私政策更新后，我们会在搜机网移动客户端发出更新版本，并在更新后的条款生效前以通知、公告等适当方式提醒你更新的内容，以便你及时了解本隐私政策的最新版本。如你继续使用我们的服务，表示同意接受修订后的本政策的内容，但是如果更新的内容需要采集新的个人敏感信息，仍会再次以显著方式征求你的同意。
    </p>
    <p>（三）对于重大变更，我们还会提供更为显著的通知(包括对于某些服务，我们会通过电子邮件发送通知，说明隐私政策的具体变更内容)</p>
    <p>1、我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等;</p>
    <p>2、我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等;</p>
    <p>3、个人信息共享、转让或公开披露的主要对象发生变化;</p>
    <p>4、您参与个人信息处理方面的权利及其行使方式发生重大变化;</p>
    <p>5、我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时;</p>
    <p>6、个人信息安全影响评估报告表明存在高风险时。我们还会将本政策的旧版本存档，供您查阅。</p>
    <p>
      7.我们将在修订生效前通过在主页上显著位置提示或向您发送电子邮件或以其他方式通知您。未经您的明确同意，我们不会削减您基于本《隐私政策》所享有的权利。如该等修订造成您在本《隐私政策》下权利的实质减少，而您继续使用我们的服务，即表示同意受经修订的本《隐私政策》的约束。
    </p>
    <p>8.如无特殊说明，修订后的《隐私政策》自公布之日起生效。</p>
    <p>九、信息安全</p>
    <p>（一） 平台帐号均有安全保护功能，请妥善保管您的用户名及密码信息。平台将通过对用户密码进行加密等安全措施确保您的信息不丢失，不被滥用和变造。尽管有前述安全措施，但同时也请您注意在信息网络上不存在“完善的安全措施”。</p>
    <p>（二）
      在使用平台网络服务时，您不可避免的要披露自己的个人信息，如联络方式等。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息泄密，尤其是平台用户名及密码发生泄露，请您立即联络平台客服，以便平台采取相应措施。
    </p>
    <p>十、您如何联系我们</p>
    <p>（一）如果您对本政策或您在使用我们的服务过程中有任何疑问、意见或建议，您均可通过以下方式与我们取得联系：邮箱：kefu@souji168.cn</p>
    <p>（二）我们将尽快审核所涉问题，并在验证身份后及时处理，最长在不超过十五天或在法律法规规定期限内予以回复。</p>
    <p>十一、第三方SDK目录</p>
    <p>1、 SDK名称 ：App 支付宝客户端 SDK</p>
    <p>包名 ：com.alipay.sdk</p>
    <p>开发者 ：支付宝(杭州)信息技术有限公司</p>
    <p>使用目的 ：提供安全的支付服务，帮助用户完成交易、进行订单支付安全风控。</p>
    <p>收集个人信息类型 ：设备信息 ：设备标识符（IMEI、IMSI、Android ID、MAC地址）、设备型号、屏幕密度、传感器信息、运营商信息、OAID（安卓系统广告标识符）网络与连接信息 ：IP地址、Wi-Fi信息（SSID、BSSID）、基站信息、网络类型（如4G、5G、Wi-Fi）应用信息 ：软件安装列表、应用运行信息位置信息 ：粗略位置信息 交易信息 ：订单信息、支付结果</p>
    <p>官方隐私政策链接 ：https://opendocs.alipay.com/open/54/01g6qm</p>
    <p>2、 SDK名称 ：Bugly Android</p>
    <p>包名 ：com.tencent.bugly</p>
    <p>开发者 ：深圳市腾讯计算机系统有限公司</p>
    <p>使用目的 ：监控应用崩溃信息，分析性能问题，提升应用稳定性和用户体验。</p>
    <p>收集个人信息类型 ：设备信息 ：设备标识符（Android ID、IMEI、IMSI、ICCID、MEID、OAID、GAID）、设备品牌、型号、操作系统版本、分辨率、设备序列号（SN）、硬件MAC地址、传感器信息网络信息 ：IP地址、网络类型、网络信号强度、Wi-Fi信息（SSID/BSSID）日志信息 ：崩溃堆栈轨迹、进程信息、日志信息应用信息 ：软件安装列表</p>
    <p>官方隐私政策链接 ：https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56</p>
    <p>3、 SDK名称 ：友盟+应用性能监控SDK</p>
    <p>包名 ：com.umeng.umcrash</p>
    <p>开发者 ：友盟同欣（北京）科技有限公司</p>
    <p>使用目的 ：监控页面加载速度和App运行性能，分析崩溃原因，衡量页面交互流畅度。</p>
    <p>收集个人信息类型 ：设备信息 ：设备标识符（IMEI、OAID、Android ID、IDFA）、设备品牌、型号、操作系统版本、分辨率、传感器信息、运营商信息网络信息 ：IP地址、网络类型、网络信号强度、Wi-Fi信息（SSID/BSSID）性能数据 ：启动时间、页面加载时间、卡顿率、崩溃信息应用信息 ：软件安装列表</p>
    <p>官方隐私政策链接 ：https://www.umeng.com/page/policy</p>
    <p>4、 SDK名称 ：友盟+社会化分享SDK</p>
    <p>包名 ：com.umeng.socialize</p>
    <p>开发者 ：友盟同欣（北京）科技有限公司</p>
    <p>使用目的 ：支持用户将应用内容分享至微信、QQ等第三方社交平台。</p>
    <p>收集个人信息类型 ：设备信息 ：设备标识符（IMEI、OAID、Android ID）、设备品牌、型号、操作系统版本、传感器信息</p>
    <p>网络信息 ：IP地址、网络类型、Wi-Fi信息（SSID/BSSID）应用信息 ：已安装的应用列表 操作信息 ：社交平台分享操作记录</p>
    <p>官方隐私政策链接 ：https://www.umeng.com/page/policy</p>
    <p>5、 SDK名称 ：友盟+移动统计SDK</p>
    <p>包名 ：com.umeng.analytics</p>
    <p>开发者 ：友盟同欣（北京）科技有限公司</p>
    <p>使用目的 ：统计分析用户行为，提供数据分析服务，优化产品体验和运营活动。</p>
    <p>收集个人信息类型 ：设备信息 ：设备标识符（IMEI、OAID、Android ID、IDFA）、设备品牌、型号、操作系统版本、分辨率、传感器信息、运营商信息 网络信息 ：IP地址、网络类型、Wi-Fi信息（SSID/BSSID）应用使用信息 ：应用内浏览、点击、搜索、使用时长等行为数据 应用信息 ：软件安装列表</p>
    <p>官方隐私政策链接 ：https://www.umeng.com/page/policy</p>
    <p>6、 SDK名称 ：微信OpenSDK Android</p>
    <p>包名 ：com.tencent.mm.opensdk</p>
    <p>开发者 ：深圳市腾讯计算机系统有限公司</p>
    <p>使用目的 ：支持用户使用微信登录、分享内容至微信好友和朋友圈、使用微信支付。</p>
    <p>收集个人信息类型 ：设备信息 ：设备标识符（IMEI、IMSI）、设备品牌、型号、操作系统信息、传感器信息网络信息 ：IP地址、网络类型、Wi-Fi信息（SSID/BSSID）账号与操作信息 ：微信账号信息、分享和支付操作信息应用信息 ：软件安装列表</p>
    <p>官方隐私政策链接 ：https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8</p>
    <p>7、 SDK名称 ：极光推送 - JPush SDK - Android</p>
    <p>包名 ：cn.jpush.android</p>
    <p>开发者 ：深圳市和讯华谷信息技术有限公司</p>
    <p>使用目的 ：向用户推送系统消息和活动通知，管理推送链路与效果。</p>
    <p>收集个人信息类型 ：设备信息 ：设备标识符（IMEI、Android ID、JG ID）、广告标识符OAID、设备品牌、型号、操作系统版本、传感器信息</p>
    <p>网络与位置信息 ：IP地址、网络类型、Wi-Fi信息（SSID/BSSID）、粗略位置信息、精确位置信息</p>
    <p>应用信息 ：软件安装列表、推送信息记录</p>
    <p>官方隐私政策链接 ：https://www.jiguang.cn/license/privacy</p>
    <p>8、 SDK名称 ：金融级实人认证-android</p>
    <p>包名 ：com.dtf.face</p>
    <p>开发者 ：杭州阿里云智能科技有限公司</p>
    <p>使用目的 ：用于用户实名认证，通过面部识别验证身份，确保账户安全与业务合规。</p>
    <p>收集个人信息类型 ：<span style="font-weight: bold;color:#409EFF">个人身份信息 ：姓名、身份证号码个人生物识别信息 ： 面部特征信息</span> 设备信息 ：设备标识符（IMEI、IMSI）、设备品牌、型号、操作系统版本、传感器信息网络信息 ：IP地址、网络类型、Wi-Fi信息（SSID/BSSID）认证信息 ：认证过程数据及结果</p>
    <p>官方隐私政策链接 ：https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202107281509_18386.html</p>
    <p>9、 SDK名称 ：友盟组件化基础库</p>
    <p>包名 ：com.umeng.commonsdk</p>
    <p>开发者 ：友盟同欣（北京）科技有限公司</p>
    <p>使用目的 ：统计分析用户行为，提供数据分析服务，优化产品体验和运营活动。</p>
    <p>收集个人信息类型 ：收集(读取AndroidID)、设备标识符（IMEI、OAID、Android ID、IDFA）、设备品牌、型号、操作系统版本、分辨率、传感器信息、运营商信息</p>
    <p>网络信息 ：IP地址、网络类型、Wi-Fi信息（SSID/BSSID）</p>
    <p>应用使用信息 ：应用内浏览、点击、搜索、使用时长等行为数据</p>
    <p>应用信息 ：软件安装列表</p>
    <p>官方隐私政策链接 ：https://www.umeng.com/page/policy</p>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicy'
}
</script>

<style scoped>
.privacy-policy {
  width: 98%;
  margin: 0 auto;
  padding: 1%;
  font-size: 16px;
  line-height: 1.6;
  text-indent: 32px;
}

h1 {
  text-align: center;
  margin-bottom: 20px;
  text-indent: 0;
  margin-top: 10px;
}

h2 {
  margin-top: 20px;
  margin-bottom: 10px;
}

p {
  margin-bottom: 10px;
}

table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
  overflow-x: auto;
}

table th,
table td {
  border: 1px solid #ccc;
  padding: 8px;
  overflow-x: auto;
}
</style>
